const global: {
  confirm: (handleOk: (...args: unknown[]) => void) => void;
} & Record<string, any> = {
  confirm: () => {},
};
export default global;
